export enum FlightCommonTrackingEventName {
  // Fired when a user enters the Air Flow
  air_entry = "air_entry",
}
